const QuizIcon = () => {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Quiz</title>
      <path
        d="M12.3691 8.87988H17.6191"
        stroke="#0091D5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M6.38086 8.87988L7.13086 9.62988L9.38086 7.37988"
        stroke="#0091D5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M12.3691 15.8789H17.6191"
        stroke="#0091D5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M6.38086 15.8789L7.13086 16.6289L9.38086 14.3789"
        stroke="#0091D5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M9 21.998H15C20 21.998 22 19.998 22 14.998V8.99805C22 3.99805 20 1.99805 15 1.99805H9C4 1.99805 2 3.99805 2 8.99805V14.998C2 19.998 4 21.998 9 21.998Z"
        stroke="#0091D5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default QuizIcon;
